import { createFileRoute } from '@tanstack/react-router';
import AboutPage from '../../components/AboutPage';

function AboutPageRoute() {
  return <AboutPage />;
}

export const Route = createFileRoute('/_authenticated/about')({
  beforeLoad: ({ context }) => {
    return {
      ...context,
      documentTitle: {
        main: 'menu.aboutApp',
      },
    };
  },
  component: AboutPageRoute,
});
